// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3u2o3","top":"styles_top__27P3G","left":"styles_left__1jNNN","description":"styles_description__1QqpF"};